import {
  initialState,
  Actions,
  State,
  GET_ALL_SURVEY_ANSWERS,
  GET_ALL_SURVEY_ANSWERS_SUCCESS,
  GET_ALL_SURVEY_ANSWERS_ERROR,
  RESET_GET_ALL_SURVEY_ANSWERS,
} from "../../types/survey/all-answers";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_SURVEY_ANSWERS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_SURVEY_ANSWERS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_SURVEY_ANSWERS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ALL_SURVEY_ANSWERS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
